import { Box, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import Loader from '../../elements/Loader';
import { getCurrentProject } from '../../../modules/project';
import { getSlackIntegration } from '../../../modules/notification';
import AdminSlackSettings from './AdminSlackSettings';
import UserNotificationSettings from './UserNotificationSettings';

const NotificationSettings = ({ isAdmin }) => {
  const { projectId } = useParams();

  const {
    data: project,
    isLoading: projectLoading,
    isError: projectError,
    error: projectErr,
  } = useQuery({
    queryKey: ['project', projectId],
    queryFn: () => getCurrentProject(projectId),
    enabled: !!projectId,
    staleTime: 30_000,
  });

  const {
    data: slackIntegration,
    isLoading: slackIntegrationLoading,
  } = useQuery({
    queryKey: ['slackIntegration', projectId],
    queryFn: () => getSlackIntegration(projectId),
    enabled: !!projectId,
    staleTime: 30_000,
  });

  if (projectLoading || slackIntegrationLoading) return <Loader />;

  if (projectError) {
    return (
      <Box sx={{ mt: 3 }}>
        <Typography color="error">
          {projectErr?.message ?? 'Failed to load project.'}
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      {isAdmin && (
        <AdminSlackSettings
          project={project}
          slackIntegration={slackIntegration}
        />
      )}

      <UserNotificationSettings projectId={projectId} isAdmin={isAdmin} />
    </Box>
  );
};

export default NotificationSettings;